const state = {
  userNoList: [], // 户号列表
  interval: 60, // 短信验证时长
}
// 获取数据 对外暴露
const getters = {
  userNoList: () => {
    return state.userNoList
  },
  interval: () => {
    return state.interval
  }
}
// 修改数据 对外暴露
// 调用方式： store.dispatch(方法名, 参数)
const actions = {
  setUserNoList ({commit}, userNoList) {
    commit('setUserNoList', userNoList)
  },
  setInterval ({commit}, interval) {
    commit('setInterval', interval)
  },
}
// mautation 内部调用，外部不允许调用
const mutations = {
  setUserNoList (state, userNoList) {
    state.userNoList = userNoList
  },
  setInterval (state, interval) {
    state.interval = interval
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userNoList.js